export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/hn.612424f3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};